module.exports = __webpack_public_path__ + "static/media/config.5fa0a9b2.png";